<!-- K00_14_005_ユーザツリー検索画面（POPUP） -->
<template>
  <a-modal
    centered
    :width="1100"
    :title="title"
    :visible="visible"
    v-if="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <div class="user-tree-search">
      <!-- 筛选区域 -->
      <div class="filter-area">
        <div class="filter-top">
          <a-radio-group v-model="filterType">
            <a-radio-button value="1"> 按组织检索 </a-radio-button>
            <a-radio-button value="2"> 自定义组别 </a-radio-button>
            <a-radio-button value="3"> 组合检索 </a-radio-button>
          </a-radio-group>
        </div>
        <div class="filter-content">
          <!-- 组织树 -->
          <div v-if="filterType == '1'" class="depart-box">
            <!-- 检索部 -->
            <a-form-model layout="inline" @keyup.enter.native="onSearch">
              <a-input
                placeholder="人员姓名模糊查询"
                style="margin-bottom: 12px; width: 331px"
                v-model="searchText"
                @change="onSearch"
                allowClear
              ></a-input>
              <!-- <a-button style="margin-left: 21px" type="primary" @click="onSearch" icon="search">{{
              this.$t('disp.btn.search')
            }}</a-button>
            <a-button @click="searchReset" icon="stop">
              {{ this.$t('disp.btn.reset') }}
            </a-button> -->
            </a-form-model>
            <div class="a-tree">
              <a-tree
                class="depart-tree-root-icon"
                :treeData="treeData"
                :expandedKeys="expandedKeys"
                :selectedKeys="selectedKeys"
                @select="onSelect"
                @expand="onExpand"
              >
                <span slot="hasSlot" slot-scope="{ key, title, orgType, userCount }">
                  <span>{{ title }}</span>
                  <span v-if="userCount > 0" class="userCount">（{{ userCount }}）</span>
                  <span
                    v-if="orgType == '1' && params.departFlg != '1'"
                    class="expand-trigger"
                    @click.stop="handleExpand(key)"
                    >全部展开</span
                  >
                </span>
              </a-tree>
              <a-empty v-if="treeData.length == 0" />
            </div>
          </div>

          <!-- 自定义组别 -->
          <div v-if="filterType == '2'" class="group-box">
            <div class="group-content">
              <div v-for="(group, index) in groupList" :key="index" class="group-wrapper-outer">
                <div
                  class="group-wrapper selected"
                  :class="[
                    'border-color-' + group.markColor,
                    selectedGroupIds.indexOf(group.id) >= 0 ? 'selected' : '',
                  ]"
                  @click="onClickGroup(group)"
                >
                  <div
                    class="markColor"
                    :class="group.markColor"
                    :style="
                      'background: linear-gradient(90deg, var(--color-' +
                      group.markColor +
                      '-6), var(--color-' +
                      group.markColor +
                      '-3));'
                    "
                  ></div>

                  <span style="letter-spacing: 1px" :title="group.groupName">{{ group.groupName }}</span>

                  <!-- <a-checkbox :checked="selectedGroupIds.includes(group.id)" :value="group.id"></a-checkbox> -->
                </div>

                <a-popover placement="right">
                  <template slot="content">
                    <div style="max-width: 250px">{{ group.groupUserNames }}</div>
                    <div style="display: flex; justify-content: flex-end; margin-bottom: -10px; margin-top: 10px">
                      <a-button type="primary" size="small" @click="$refs.CustomGroup.edit(group)">编辑</a-button>

                      <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => groupDelete(group.id)">
                        <a-button type="primary" size="small">删除</a-button>
                      </a-popconfirm>
                    </div>
                  </template>
                  <a-icon type="more" />
                </a-popover>
              </div>
            </div>

            <div
              class="group-wrapper new"
              :class="groupList.length == 0 ? 'no-data' : ''"
              @click="$refs.CustomGroup.add()"
            >
              <a-icon type="plus" />
              <span>新增组别</span>
            </div>
          </div>

          <!-- 组合筛选 -->
          <div v-if="filterType == '3'" class="collect-box">
            <div>
              <a-form-model class="hide-scroll">
                <a-form-model-item label="所属信息" prop="departId" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tree-select
                    v-model="collectParam.departId"
                    :treeData="departTree"
                    treeDefaultExpandAll
                    placeholder="请选择所属信息"
                    :allowClear="true"
                    @change="collectDepartChange"
                  ></a-tree-select>
                </a-form-model-item>

                <a-form-model-item label="职位" prop="postId" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    v-model="collectParam.postId"
                    placeholder="请选择职位"
                    :options="positionList"
                    @change="collectPostChange"
                  ></a-select>
                  <!-- <j-dict-select-tag
                  v-model="collectParam.postId"
                  placeholder="请选择职位"
                  :dictCode="positionList"
                  :showSearch="true"
                  :filterOption="filterOption"
                  @change="collectPostChange"
                /> -->
                </a-form-model-item>

                <a-form-model-item label="角色" prop="roleId" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    v-model="collectParam.roleId"
                    placeholder="请选择角色"
                    :options="roleList"
                    :showSearch="true"
                    :filterOption="filterOption"
                    @change="collectRoleChange"
                  ></a-select>
                </a-form-model-item>
              </a-form-model>
            </div>
          </div>
        </div>
      </div>
      <!-- 待选区域 -->
      <div class="data-checked">
        <div v-if="dataSource.length > 0 && params.multiFlg == '1'" class="div-op-btn">
          <a-button type="primary" ghost="" size="small" @click="checkAll" icon="check">全选</a-button>
          <a-button type="primary" ghost="" size="small" @click="clearAll" icon="close">清空</a-button>
        </div>

        <a-checkbox-group
          @change="onChange"
          v-model="checkedValue"
          v-if="dataSource.length > 0 && params.multiFlg == '1'"
        >
          <a-checkbox v-for="item in dataSource" :key="item.value" :value="item.value">
            <span>{{ item.label }}</span>
            <span class="note" style="letter-spacing: 1px" v-if="params.departFlg == '1'">（{{ item.username }}）</span>
          </a-checkbox>
        </a-checkbox-group>

        <a-radio-group @change="onChange" v-model="radioValue" v-if="dataSource.length > 0 && params.multiFlg == '0'">
          <a-radio v-for="item in dataSource" :key="item.value" :value="item.value">
            <span>{{ item.label }}</span>
            <span class="note" style="letter-spacing: 1px" v-if="params.departFlg == '1'">（{{ item.username }}）</span>
          </a-radio>
        </a-radio-group>

        <a-empty v-if="dataSource.length == 0" />
      </div>

      <!-- 已选区域 -->
      <div class="tag-checked">
        <div v-if="tagDisplayRows.length > 0">
          <div class="a-tag" v-for="item in tagDisplayRows" :key="item.id">
            <a-tooltip v-if="item.departName && params.splitByDepart">
              <template slot="title">{{ item.departName }}</template>
              <a-tag class="primary" closable @close="closeTag(item)">{{ item.label }}</a-tag>
            </a-tooltip>
            <a-tag v-else class="primary" closable @close="closeTag(item)">{{ item.label }}</a-tag>
          </div>
        </div>
        <a-empty v-else />
      </div>
    </div>

    <CustomGroup ref="CustomGroup" @emit="searchGroup"></CustomGroup>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from '@/api/manage'
import { ajaxGetDictItems } from '@/api/api'
import CustomGroup from './CustomGroup'

export default {
  name: 'SelectUserTreeModal',
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          // マルチフラグ 0：シングル選択、1：マルチ選択
          multiFlg: '1',
          // 組織フラグ 0：全組織 1：自会社 2：他会社 3:得意先 4:仕入先
          departFlg: '1',
          // 選択したユーザリスト ユーザリスト[{value:'',text:''}]
          selectUserList: [],
          // 为true的时候,即使是同一个人,从属于多个组织的话会被视为多个人
          // 废弃
          splitByDepart: false,
          // 父页面
          parent: '',
          // 指定用户列表(有值时将只展示这些用户)
          limitUserIds: '',
        }
      },
    },
  },
  components: { CustomGroup },
  data() {
    return {
      // タイトル
      title: this.$t('disp.userTreeSearch.title'),
      // 検索文字列
      searchText: '',
      // 前回検索文字列
      searchTextBackup: '',
      // 表示
      visible: false,
      // ツリー選択ノード
      selectedKeys: [],
      // treeNodes データ
      treeData: [],
      // 自動的に親ノードを表示
      autoExpandParent: true,
      // 指定されたツリーノードを表示
      expandedKeys: [],
      // データソース
      dataSource: [],
      // データソース Value
      dataSourceValue: [],
      // 選択されたvalue
      checkedValue: [],
      // 選択されたvalue
      radioValue: '',
      // 選択された checkedValue rowsを取得できる
      checkedRows: [],
      // tag データ表示 value
      tagDisplayValue: [],
      // tag キャッシュ表示データ value
      tagDisplayValueOld: [],
      // tag データ表示
      tagDisplayRows: [],
      // tag  キャッシュ表示データ
      tagDisplayRowsOld: [],
      disabled: false,
      transferShow: true,
      // 检索方式：1:按组织检索;2:自定义组别;3:组合检索;
      filterType: '1',
      // 自定义组别
      groupList: [],
      selectedGroupIds: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      // 单位树数据源
      departTree: [],
      // 职位下拉数据源
      positionList: [],
      // 角色下拉数据源
      roleList: [],
      // 组合查询条件
      collectParam: {
        departId: undefined,
        postId: undefined,
        roleId: undefined,
      },
      // URLパス
      url: {
        getUserDepartCompanyTree: '/blaze-sys/k00/k0002/DepartManage/getUserDepartCompanyTree',
        getSelectUserTreeModal: '/blaze-sys/k00/k0014/UserManage/getSelectUserTreeModal',
        groupList: '/blaze-sys/k00/k0002/DepartManage/getGroupUserPageList',
        groupDelete: '/blaze-sys/k00/k0002/DepartManage/groupDelete',
        getRoles: '/blaze-sys/k00/k0003/RoleManage/getRoles',
        getCandidateUsers: '/blaze-sys/k00/k0014/UserManage/getCandidateUsers',
      },
    }
  },
  created() {
    if (!this.params.multiFlg) {
      this.params.multiFlg = '1'
    }
    if (!this.params.departFlg) {
      this.params.departFlg = '0'
    }
    if (!this.params.selectUserList) {
      this.params.selectUserList = []
    }
    if (!this.params.parent) {
      this.params.parent = ''
    }
    // 废弃splitByDepart属性
    this.splitByDepart = false

    // 去除value为null的初始数据
    XEUtils.remove(this.params.selectUserList, (r) => XEUtils.isNull(r.value))
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loadDepart()
      this.searchGroup()

      this.getDeparts()
      this.getPosts()
      this.getRoles()
    },
    // tag ラベルを閉じる
    closeTag(val) {
      // tag データを表示
      this.tagDisplayRows = this.tagDisplayRows.filter((item) => {
        return item.value != val.value
      })
      // tag  キャッシュ表示データ
      this.tagDisplayRowsOld = this.tagDisplayRows
      // tag データvalue を表示
      this.tagDisplayValue = this.tagDisplayRows.map((v) => v.value)

      if (this.params.multiFlg == 0) {
        // 選択されたvalue
        this.radioValue = ''
      } else {
        // 選択されたvalue
        this.checkedValue = this.dataSourceValue.filter((val) => {
          return this.tagDisplayValue.indexOf(val) > -1
        })
      }
    },

    // checkbox-group チェンジ
    onChange(checkedValues) {
      console.log(this.checkedValue)
      if (this.params.multiFlg == 0) {
        // 選択されたvalue
        this.checkedRows = this.getCheckedRows(checkedValues.target.value, this.dataSource)
      } else {
        // 選択されたvalue
        this.checkedRows = this.getCheckedRows(checkedValues, this.dataSource)
      }

      // データ行列重複除去
      let listRows = this.arrayDiff(this.tagDisplayRowsOld, this.dataSource, 'value')

      if (this.params.multiFlg == 0) {
        // データ表示
        this.tagDisplayRows = this.checkedRows
      } else {
        // データ表示
        this.tagDisplayRows = [...listRows, ...this.checkedRows]
      }

      // tag キャッシュ表示データ
      this.tagDisplayRowsOld = this.tagDisplayRows

      // データ valueを表示
      this.tagDisplayValue = this.tagDisplayRows.map((v) => v.value)
    },

    checkAll() {
      this.checkedValue = XEUtils.map(this.dataSource, (r) => r.value)
      this.onChange(this.checkedValue)
    },

    clearAll() {
      this.checkedValue = []
      this.onChange(this.checkedValue)
    },

    getCheckedRows(val, list) {
      let rows = []

      if (this.params.multiFlg == 0) {
        let row = list.find((item) => {
          return item.value == val
        })
        rows.push(row)
      } else {
        val.forEach((v) => {
          let row = list.find((item) => {
            return item.value == v
          })
          rows.push(row)
        })
      }
      return rows
    },
    // ①初期表示
    // 	属性チェック：なし
    // 	業務チェック：なし
    // 初期化 tree
    loadDepart(initFlg) {
      // 初期化tag
      this.tagInit(initFlg)
      var param = {}
      param.departFlg = this.params.departFlg
      if (!this.params.departFlg) {
        param.departFlg = '0'
      }
      param.searchText = this.searchText
      param.parent = this.params.parent
      param.limitUserIds = this.params.limitUserIds
      this.searchTextBackup = this.searchText

      // 1)	組織ツリー情報を取得する。								※検索仕様①
      postAction(this.url.getUserDepartCompanyTree, param).then((res) => {
        if (res.success) {
          this.treeData = []
          this.checkedRows = []
          this.checkedKeys = []
          this.expandedKeys = []
          this.selectedKeys = []
          this.dataSource = []

          if (res.result) {
            res.result.map((item) => this.setThisExpandedKeys(item))
          }
          this.$nextTick(() => {
            this.treeData = res.result
          })
        }
      })
    },
    onSearch() {
      this.loadDepart('1')
    },
    searchReset() {
      this.searchText = ''
    },
    // 2)	組織ツリー情報より、組織ツリーを作成する。
    // 初期化tag
    tagInit(initFlg) {
      if (initFlg && initFlg == '1') {
        return
      }

      if (this.params.selectUserList && this.params.selectUserList.length > 0) {
        this.params.selectUserList.forEach((item) => {
          item.key = item.value
          item.label = item.text
        })
        // データ表示
        this.tagDisplayRows = this.params.selectUserList
        // tag  缓存显示数据
        this.tagDisplayRowsOld = this.tagDisplayRows
        // データ valueを表示
        this.tagDisplayValue = this.tagDisplayRows.map((v) => v.value)
      }
    },
    handleExpand(key) {
      var target = XEUtils.first(XEUtils.filterTree(this.treeData, (r) => r.key == key))
      this.setThisExpandedKeys(target, true)
    },
    // 指定されたツリーノードを開く
    setThisExpandedKeys(node, forceExpand) {
      if (node.children && node.children.length > 0) {
        // 检索其他公司的时候因为数量较多默认不展开
        if (forceExpand || this.searchText || this.params.departFlg == '1') {
          this.expandedKeys.push(node.id)
        }

        for (let i = 0; i < node.children.length; i++) {
          this.setThisExpandedKeys(node.children[i], forceExpand)
        }
      }
    },
    // 開く/収めるノードの時トリガー
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // ②エリア１の組織ツリーに組織名をクリックする
    // 	属性チェック：				なし
    // 	業務チェック：なし
    // 	処理仕様：
    // 		■選択した組織.組織情報の自社フラグ =  1:自会社の場合

    // ツリーノードをクリックトリガー
    onSelect(selectedKeys, e) {
      // 清空其他检索参数
      this.clearOtherFilterParam()

      this.selectedKeys = selectedKeys

      let record = e.node.dataRef
      let param = {}
      // 組織ID
      param.departId = record.id
      // 組織コード
      param.orgCode = record.orgCode
      // 自社フラグ
      param.myCompanyFlag = record.myCompanyFlag
      // 検索文字列
      param.searchText = this.searchTextBackup
      // 組織フラグ 0：全組織 1：自会社 2：他会社 3:得意先 4:仕入先
      param.departFlg = this.params.departFlg
      // 父页面
      param.parent = this.params.parent
      // 限定用户
      param.limitUserIds = this.params.limitUserIds

      var that = this
      postAction(this.url.getSelectUserTreeModal, param).then((res) => {
        if (res.success) {
          // this.transferShow = true
          if (res.result.length) {
            res.result.forEach((item, index) => {
              item.key = that.params.splitByDepart ? item.userId + ';' + item.departId : item.userId
              if (item.realname) {
                item.title = item.realname
              } else {
                item.title = ''
              }
              item.value = that.params.splitByDepart ? item.userId + ';' + item.departId : item.userId
              item.label = item.realname
            })
          }

          // 设置待选区域数据源以及已选择项
          that.setDataSourceAndChecked(res.result)
        }
      })
    },
    // 设置待选区域数据源以及已选择项
    setDataSourceAndChecked(dataSource) {
      // データソース
      this.dataSource = dataSource
      // データソース Value
      this.dataSourceValue = this.dataSource.map((v) => v.value)

      if (this.params.multiFlg == 0) {
        // 選択されたvalue
        let obj = this.dataSourceValue.filter((val) => {
          return this.tagDisplayValue.indexOf(val) > -1
        })
        if (obj && obj.length > 0) {
          this.radioValue = obj[0]
        }
      } else {
        // 選択されたvalue
        this.checkedValue = this.dataSourceValue.filter((val) => {
          return this.tagDisplayValue.indexOf(val) > -1
        })
      }
    },
    // ③エリア２のユーザ名をクリックする
    // 	属性チェック：				なし
    // 	業務チェック：なし
    // 	処理仕様：
    // 		ユーザ名を選択する
    // 		選択した仕様は上記レイアウトのエリア２を参照する
    // 	項目編集：なし
    // 右サイドに表示するデータの選択されたのデータリスト
    getTargetSelectedInfo(targetKeys, dataSource) {
      let rows = []
      const forList = (list, key) => {
        for (let item of list) {
          if (item.key == key) {
            return item
          }
        }
        return null
      }
      for (let key of targetKeys) {
        let row = forList(dataSource, key)
        rows.push(row)
      }
      return rows
    },
    // ⑬「確定」をクリックする
    // 属性チェック：なし
    // 業務チェック：
    // エリア３にユーザがない場合、処理中止、メッセージを表示する。
    // メッセージID：msg.E_K0014005_01
    // メッセージ内容：ユーザを選択してください。
    // 処理仕様：
    // 1) エリア３のユーザリストを戻る
    // 2) 画面を閉じる
    // 提出確定
    handleSubmit() {
      if (this.tagDisplayRows.length) {
        for (let item of this.tagDisplayRows) {
          item.id = item.value.split(';')[0]
          item.value = item.value.split(';')[0]
          item.text = item.realname || item.text
        }
        this.$emit('input', this.tagDisplayRows)
        this.$emit('change', this.tagDisplayRows)
        this.$emit('emit', this.tagDisplayRows)
        // popupを閉じる
        this.handleCancel()
      } else {
        this.$message.warn(this.$t('disp.rules.select'))
      }
    },

    // アレイ重複除去  outputList データ出力   parallelList データ比較   key重複除去条件
    arrayDiff(outputList, parallelList, key) {
      let a = JSON.parse(JSON.stringify(outputList))
      for (var i = 0; i < parallelList.length; i++) {
        for (var j = 0; j < a.length; j++) {
          if (a[j][key] == parallelList[i][key]) {
            a.splice(j, 1)
            j = j - 1
          }
        }
      }
      return a
    },
    // ⑫ボタン11をクリックする
    // 属性チェック：				なし
    // 業務チェック：なし
    // 処理仕様：
    // １）エリア３に選択したユーザがある場合
    // 選択したユーザ名をリストの最後の行に移動する
    // ２）エリア３にユーザがない、また選択しない場合
    // 処理なし
    // 項目編集：なし
    // popupを閉じる
    handleCancel() {
      this.handleClear()
    },

    handleClear() {
      this.visible = false
      // tree ツリーメニュー
      this.checkedKeys = []
      this.checkedRows = []
      this.expandedKeys = []
      // checkbox
      this.dataSource = []
      this.checkedValue = []
      this.radioValue = ''
      this.checkedRows = []
      /// tag
      this.tagDisplayValue = []
      this.tagDisplayValueOld = []
      this.tagDisplayRows = []
      this.tagDisplayRowsOld = []
    },
    // 查询自定义组别数据
    searchGroup() {
      postAction(this.url.groupList, { pageNo: 1, pageSize: 999999999 }).then((res) => {
        if (res.success) {
          this.groupList = res.result ? res.result.records : []
        }
      })
    },
    // 删除自定义组别
    groupDelete(groupId) {
      deleteAction(this.url.groupDelete, {
        id: groupId,
      }).then(async (res) => {
        if (res.success) {
          this.$message.success(this.$t(res.message))
          await this.searchGroup()
        }
      })
    },
    // 点击自定义组别事件
    onClickGroup(group) {
      // 清空其他检索参数
      this.clearOtherFilterParam()

      var that = this
      let users = []
      if (group.groupUsers.length) {
        if (this.params.limitUserIds) {
          // limitUserIds过滤
          users = XEUtils.filter(group.groupUsers, (item) =>
            XEUtils.includes(this.params.limitUserIds.split(','), item.id)
          )
        } else {
          users = group.groupUsers
        }
        users.forEach((item, index) => {
          item.key = item.id
          if (item.realname) {
            item.title = item.realname
          } else {
            item.title = ''
          }
          item.value = item.id
          item.label = item.realname
        })
      }

      // 设置待选区域数据源以及已选择项
      that.setDataSourceAndChecked(users)
    },
    // 组合检索_所属信息下拉数据源
    getDeparts() {
      let departs = []
      departs.push({
        key: 'starter_user_id',
        value: 'starter_user_id',
        title: '当前登陆用户自己',
      })
      departs.push({
        key: 'starter_supervisor_id',
        value: 'starter_supervisor_id',
        title: '当前登陆用户的直属上级',
      })
      departs.push({
        key: 'starter_depart_id',
        value: 'starter_depart_id',
        title: '当前登陆用户所属部门',
      })
      departs.push({
        key: 'starter_region_id',
        value: 'starter_region_id',
        title: '当前登陆用户所属大区',
      })
      // departs.push({
      //   key: 'starter_company_id',
      //   value: 'starter_company_id',
      //   title: '当前登陆用户所属公司',
      // })
      departs.push({
        key: '-999',
        value: '-999',
        title: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -',
      })
      this.departTree = departs.concat(this.$getDepartTree())
    },
    // 组合检索_职位下拉数据源
    getPosts() {
      let posts = []
      posts.push({
        key: 'depart_leader',
        value: 'depart_leader',
        text: '部门负责人',
      })
      posts.push({
        key: 'depart_branch_leader',
        value: 'depart_branch_leader',
        text: '部门分管领导',
      })
      posts.push({
        key: '-999',
        value: '-999',
        text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -',
      })
      posts = posts.concat(this.$getPosition())
      posts.forEach((r) => {
        r.title = r.text
      })
      this.positionList = posts
    },
    // 组合检索_角色下拉数据源
    async getRoles() {
      //根据字典Code, 初始化字典数组
      await ajaxGetDictItems(
        'sys_role;role_name;id;del_flag = 0 and system_flag = false order by role_name asc',
        null
      ).then((res) => {
        if (res.success) {
          this.roleList = res.result ? res.result : []
        }
      })
    },
    // 组织检索条件中所属信息选择改变
    collectDepartChange() {
      if (this.collectParam.departId == '-999') {
        this.collectParam.departId = undefined
      }
      this.getCandidateUsers()
    },
    // 组织检索条件中职位选择改变
    collectPostChange() {
      if (this.collectParam.postId == '-999') {
        this.collectParam.postId = undefined
      }
      this.getCandidateUsers()
    },
    // 组织检索条件中角色选择改变
    collectRoleChange() {
      this.getCandidateUsers()
    },
    // 是否根据输入项进行筛选
    filterOption(input, option) {
      return option.componentOptions.children[0].data.attrs.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 根据组合检索条件查询用户
    getCandidateUsers() {
      // 清空其他检索参数
      this.clearOtherFilterParam()

      // 参数都为空是不查询
      if (!this.collectParam.departId && !this.collectParam.postId && !this.collectParam.roleId) {
        // 设置待选区域数据源以及已选择项
        this.setDataSourceAndChecked([])
        return
      }

      // 限定用户
      this.collectParam.limitUserIds = this.params.limitUserIds

      var that = this
      getAction(this.url.getCandidateUsers, this.collectParam).then((res) => {
        if (res.success) {
          if (res.result.length) {
            res.result.forEach((item, index) => {
              item.key = that.params.splitByDepart ? item.id + ';' + item.departId : item.id
              if (item.realname) {
                item.title = item.realname
              } else {
                item.title = ''
              }
              item.value = that.params.splitByDepart ? item.id + ';' + item.departId : item.id
              item.label = item.realname
            })
          }

          // 设置待选区域数据源以及已选择项
          that.setDataSourceAndChecked(res.result)
        }
      })
    },
    // 清空组合检查条件
    clearCollectParam() {
      this.collectParam.departId = undefined
      this.collectParam.postId = undefined
      this.collectParam.roleId = undefined
    },
    // 清空检索条件
    clearOtherFilterParam() {
      switch (this.filterType) {
        // 按部门检索
        case '1':
          this.clearCollectParam()
          break
        // 自定义组别
        case '2':
          this.selectedKeys = []
          this.clearCollectParam()
          break
        // 组合检索
        case '3':
          this.selectedKeys = []
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.ant-tag {
  display: block !important;
  white-space: normal;
}
.ant-tree {
  > :global(li:first-child) {
    margin-top: -11px;
  }
}
.user-tree-search {
  display: flex;

  & > div {
    padding: 15px;
    border: 1px solid var(--color-input-border);
    // box-shadow: 0px 0px 10px 0px #e2e2e2 inset;
    max-height: calc(100vh - 200px);
  }

  .filter-area {
    flex: 1;
    overflow-y: auto;
    padding: 10px 15px;

    .filter-content {
      height: calc(100% - 60px);
      overflow-y: scroll;
      margin-top: 20px;
    }

    .depart-box {
      // height: calc(100% - 300px);
      // min-height: 300px;
      overflow: hidden;
      position: relative;

      .a-tree {
        overflow-y: auto;
        height: calc(100% - 75px);
      }
    }

    .group-box {
      .ant-checkbox-wrapper {
        position: absolute;
        right: 1px;
        top: 8px;
      }

      .group-wrapper-outer {
        position: relative;
        width: calc(50% - 25px);
        display: inline-block;
        margin-right: 24px;

        &:hover {
          .anticon-more {
            opacity: 1;
          }
        }

        .anticon-more {
          color: rgba(0, 0, 0, 0.25);
          position: absolute;
          top: 4px;
          right: -24px;
          font-size: 28px;
          opacity: 0;
          transition: all 0.3s;
          cursor: pointer;
          transform: scaleY(0.84);

          &:hover {
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }

      .group-wrapper {
        position: relative;
        border: 0px solid var(--color-input-border);
        height: 35px;
        line-height: 35px;
        margin-top: 1px;
        margin-bottom: 12px;
        padding: 0px 15px;
        color: black;
        cursor: pointer;
        background: linear-gradient(90deg, #fbfbfb, #f8f8f8);
        transition: all 0.3s;
        z-index: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:before {
          content: '';
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          transform: scaleX(0);
          transform-origin: 0 50%;
          transition-property: transform;
          transition-duration: 0s;
          transition-timing-function: ease-out;
        }

        /deep/ .ant-checkbox-checked:after {
          border: inherit;
        }

        /deep/ .ant-checkbox-input:focus + .ant-checkbox-inner,
        /deep/ .ant-checkbox:hover .ant-checkbox-inner {
          border: 1px solid #d9d9d9;
        }

        &.selected {
          &::before {
            transition-duration: 0.3s;
            transform: scaleX(1);
            transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
          }
        }

        &.border-color-blue {
          &::before {
            background: linear-gradient(90deg, var(--color-blue-01p), var(--color-blue-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-blue-6);
            background-color: var(--color-blue-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-blue-6);
          }
        }

        &.border-color-geek {
          &::before {
            background: linear-gradient(90deg, var(--color-geek-01p), var(--color-geek-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-geek-6);
            background-color: var(--color-geek-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-geek-6);
          }
        }

        &.border-color-green {
          &::before {
            background: linear-gradient(90deg, var(--color-green-01p), var(--color-green-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-green-6);
            background-color: var(--color-green-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-green-6);
          }
        }

        &.border-color-cyan {
          &::before {
            background: linear-gradient(90deg, var(--color-cyan-01p), var(--color-cyan-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-cyan-6);
            background-color: var(--color-cyan-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-cyan-6);
          }
        }

        &.border-color-yellow {
          &::before {
            background: linear-gradient(90deg, var(--color-yellow-01p), var(--color-yellow-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-yellow-6);
            background-color: var(--color-yellow-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-yellow-6);
          }
        }

        &.border-color-orange {
          &::before {
            background: linear-gradient(90deg, var(--color-orange-01p), var(--color-orange-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-orange-6);
            background-color: var(--color-orange-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-orange-6);
          }
        }

        &.border-color-red {
          &::before {
            background: linear-gradient(90deg, var(--color-red-01p), var(--color-red-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-red-6);
            background-color: var(--color-red-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-red-6);
          }
        }

        &.border-color-brown {
          &::before {
            background: linear-gradient(90deg, var(--color-brown-01p), var(--color-brown-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-brown-6);
            background-color: var(--color-brown-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-brown-6);
          }
        }

        &.border-color-pink {
          &::before {
            background: linear-gradient(90deg, var(--color-pink-01p), var(--color-pink-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-pink-6);
            background-color: var(--color-pink-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-pink-6);
          }
        }

        &.border-color-purple {
          &::before {
            background: linear-gradient(90deg, var(--color-purple-01p), var(--color-purple-2));
          }

          /deep/ .ant-checkbox-checked .ant-checkbox-inner {
            border-color: var(--color-purple-6);
            background-color: var(--color-purple-6);
          }

          .ant-checkbox-wrapper:hover /deep/ .ant-checkbox-inner {
            border-color: var(--color-purple-6);
          }
        }

        .ant-badge {
          position: relative;
          left: -2px;
        }

        &.new {
          border: none;
          text-align: center;
          padding: 0;
          padding-right: 8px;
          color: var(--color-blue-6);
          transition: all 0.3s;
          border-radius: var(--border-radius);
          background: white;

          &.no-data {
            text-align: left;
            padding-left: 4px;
          }

          &:hover {
            color: var(--color-blue-8);
          }

          i {
            margin-right: 6px;
          }
        }
      }
    }
  }

  .data-checked {
    //display: flex;
    //justify-content: flex-start;
    //flex-wrap: wrap;
    overflow-x: hidden;
    overflow-y: auto;
    width: 250px;
    margin-left: 20px;
    max-height: calc(100vh - 200px);
    position: relative;

    /deep/ .ant-checkbox-group {
      display: flex;
      flex-flow: column;

      .ant-checkbox-wrapper {
        padding: 5px 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .ant-checkbox-wrapper:first-child {
        padding-top: 0px;
      }

      .ant-checkbox-wrapper:last-child {
        padding-bottom: 0px;
      }
    }
    /deep/ .ant-radio-group {
      display: flex;
      flex-flow: column;

      .ant-radio-wrapper {
        padding: 5px 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .ant-radio-wrapper:first-child {
        padding-top: 0px;
      }

      .ant-radio-wrapper:last-child {
        padding-bottom: 0px;
      }
    }
  }
  .tag-checked {
    width: 250px;
    margin-left: 20px;
    height: calc(100vh - 200px);
    overflow: auto;
    position: relative;
    // border-top-right-radius: 4px;
    // border-bottom-right-radius: 4px;

    .a-tag {
      margin-top: -3px;
      width: unset;
      display: inline-block;
    }
  }
}

.ant-empty {
  margin-top: calc(50vh - 200px);
}

.ant-tag {
  cursor: pointer;
  //box-shadow: 2px 2px 3px rgba(26, 26, 26, 10%);
  //padding: 2px 5px 3px 7px;

  /deep/ .anticon-close {
    position: relative;
    top: -1px;
  }
}

/deep/ .userCount {
  color: green;
  margin-left: 0px;
  // text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  vertical-align: bottom;
}

// .ant-tag:hover {
//   opacity: 0.6;

//   /deep/ .anticon-close {
//     color: black;
//     transform: scale(1.05);
//   }
// }

.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}

.div-op-btn {
  margin-top: -4px;
  border-bottom: 1px dashed var(--color-tb-border);
  margin-bottom: 9px;
}

/deep/ .ant-tree-treenode-switcher-close {
  &:hover {
    .expand-trigger {
      //display: inline-block;
      opacity: 1;
    }
  }
}

.expand-trigger {
  color: var(--color-primary);
  position: absolute;
  font-size: 13px;
  letter-spacing: 1px;
  //display: none;
  opacity: 0;
  right: 0px;
  transition: all 0.3s;
}
</style>
